var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69472 1.23459C6.7639 0.990569 7.19705 0.989106 7.26788 1.23265C7.5913 2.3448 8.19101 3.98869 9.09789 4.88946C10.0048 5.79023 11.6527 6.37882 12.767 6.69472C13.011 6.7639 13.0125 7.19705 12.7689 7.26788C11.6568 7.5913 10.0129 8.19101 9.11211 9.09789C8.21134 10.0048 7.62274 11.6527 7.30684 12.767C7.23766 13.011 6.80451 13.0125 6.73369 12.7689C6.41026 11.6568 5.81055 10.0129 4.90367 9.11211C3.9968 8.21134 2.3489 7.62274 1.23459 7.30684C0.990568 7.23766 0.989106 6.80451 1.23265 6.73369C2.3448 6.41026 3.98869 5.81055 4.88946 4.90367C5.79023 3.9968 6.37882 2.3489 6.69472 1.23459Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp);
export default __webpack_public_path__ + "static/media/exp.3a984dece656acf6f1750d02d4d30ed9.svg";
export { ForwardRef as ReactComponent };